import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { CONTAINED_VARIANT, NO_ICON, SIZE_44 } from '@yme/atoms/button';
import { Col, Container, Row } from '@yme/atoms/grid';
import { RichText } from '@yme/atoms/rich-text';
import { useWindowSize } from '@yme/common/hooks';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { HeadingLevel2, HeadingLevel4 } from '@yme/tokens/typography';
import { DigitalDataMutation, getSanitizeHtml, isPDFlink, setDigitalData } from '@yme/utils/common';
import extractModelId from '../../utils/extract-model-id';
import { TEXT_BLOCK_DATA_TEST_ID, YPEC_SSS_YAMAHA_DOMAIN } from './constants';
import { ButtonLinkStyled, ButtonStyled, SubtitleStyled, TextBlockStyled, TitleStyled, } from './styled';
export function TextBlock(props) {
    const { title, subtitle, text, button, isRemoveBottomIndent, cqPath } = props;
    const isRightToLeft = useSelector(getRTL);
    const { isMobileView } = useWindowSize();
    const adobeAnalyticHandler = useCallback((url) => () => {
        if (url.includes(YPEC_SSS_YAMAHA_DOMAIN)) {
            setDigitalData(DigitalDataMutation.OPEN_PARTS_CATALOG, {
                url,
            });
        }
    }, []);
    if (!text) {
        return null;
    }
    const sanitizedText = getSanitizeHtml(text);
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { dataTestId: TEXT_BLOCK_DATA_TEST_ID, isRightToLeft: isRightToLeft },
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 6 },
                    React.createElement(TextBlockStyled, { isRightToLeft: isRightToLeft },
                        title && (React.createElement(TitleStyled, null,
                            React.createElement(HeadingLevel2, null, title))),
                        subtitle && (React.createElement(SubtitleStyled, null,
                            React.createElement(HeadingLevel4, { color: colorCoreBlack300 }, subtitle))),
                        React.createElement(RichText, { id: extractModelId(cqPath), text: sanitizedText, paragraphTextColor: colorCoreBlack900Base }),
                        button && (React.createElement(ButtonStyled, null,
                            React.createElement(ButtonLinkStyled, { buttonWidth: isMobileView ? '100%' : 'auto', buttonVariant: CONTAINED_VARIANT, isDarkMode: false, isExternal: isPDFlink(button.link), buttonLink: button.link, hasIconButton: NO_ICON, size: SIZE_44, onClick: adobeAnalyticHandler(button.link), buttonLabel: button.text, buttonTitle: button.text })))))))));
}
TextBlock.displayName = 'News_TextBlock_AEMComponent';
